import React, { useEffect, useState } from 'react';
import { SelectExtended } from '../../../components/inputs-group/inputs/core/select-extended';
import { InputsGroup } from '../../../components/screen/inputs-group';
import { FIELD_NAME } from '../../../constants/form-constants';
import { useApp } from '../../../contexts/app-context';
import { formService } from '../../../form-service';
import { getCarlines } from '../../../service/api/get-carlines';
import { externalContentManager } from '../../../service/external-content';
import { Carline } from '../../../types/vehicle-types';
import { normalizeString } from '../../../utils/string-utils';

interface Props {
	label?: string;
	required?: boolean;
}

type CarlineOptionValue = Carline & {
	transformacion?: string;
};

export function SolucionesEstandarizadasCarlineSelect(props: Props) {
	const { label } = props;
	const { setAppError, setAppErrorLog } = useApp();
	const [options, setOptions] = useState<{ text: string; value: any }[]>([]);
	const [selectedValue, setSelectedValue] = useState<any>(undefined);

	useEffect(() => {
		getCarlines().then((carlines) => {
			if (!carlines) {
				setAppError(true);
				setAppErrorLog('No se ha obtenido ningún carline.');
			} else if (carlines) {
				mapppingCarlineOptions(carlines);
			}
		});
	}, []);

	const normalizeForComparison = (text: string): string => {
		return normalizeString(text).toLowerCase().replace(/\s+/g, '-');
	};

	const mapppingCarlineOptions = (carlines: Carline[]) => {
		// Generamos una opcion por cada transformacion disponible del carline.
		let mappedOptions = carlines
			.sort((a, b) => a.title.localeCompare(b.title))
			.reduce<{ text: string; value: CarlineOptionValue }[]>((accumulator, carline) => {
				(carline.transformaciones || []).forEach((transformacion: string) => {
					accumulator.push({
						text: `${carline.nuevo ? 'Nuevo ' : ''}${carline.title} ${transformacion}`,
						value: { ...carline, transformacion },
					});
				});
				return accumulator;
			}, []);

		// Filtrar por externalContentManager.transformaciones si hay datos
		const transformaciones = externalContentManager.transformaciones ?? [];
		if (transformaciones.length > 0) {
			const filteredOptions = mappedOptions.filter((option) =>
				transformaciones.includes(normalizeForComparison(option.text)),
			);

			// Si el resultado está vacío, volver a llenarla como al inicio
			mappedOptions = filteredOptions.length > 0 ? filteredOptions : mappedOptions;
		}

		// Si solo queda una opción, preseleccionarla
		if (mappedOptions.length === 1) {
			setSelectedValue(mappedOptions[0].value);
			formService.setFieldValue(FIELD_NAME.CARLINE, mappedOptions[0].value);
		} else {
			setSelectedValue(undefined);
		}

		setOptions(mappedOptions);
	};

	return (
		<InputsGroup>
			<SelectExtended
				{...props}
				name={FIELD_NAME.CARLINE}
				label={label ? label : 'Modelo'}
				options={options}
				value={selectedValue}
				disabled={Boolean(selectedValue)}
			/>
		</InputsGroup>
	);
}
